import ClubEmployee from './ClubEmployee';
import Team from './Team';
import {format} from '@legacy/js/date/date-fns.js';

export default class ClubEmployeeTeamRelation {

    static fromData(data) {
        if (!data) {
            return;
        }

        let teamEmployeeRelation = new ClubEmployeeTeamRelation();
        teamEmployeeRelation.id = data.id;
        teamEmployeeRelation.team = Team.fromData(data.team);
        teamEmployeeRelation.employee = ClubEmployee.fromData(data.employee);
        teamEmployeeRelation.start = new Date(data.start);
        teamEmployeeRelation.end = data.end !== null ? new Date(data.end) : null;
        teamEmployeeRelation.isEditable = data.isEditable;
        teamEmployeeRelation.isDeletable = data.isDeletable;

        Object.seal(teamEmployeeRelation);
        return teamEmployeeRelation;
    }

    toData() {
        let start = new Date(this.start);
        let end = this.end === null ? null : new Date(this.end);

        return {
            id: this.id,
            team: this.team,
            start: format(start, 'dd.MM.yyyy'),
            end: end === null ? null : format(end, 'dd.MM.yyyy'),
            employee: this.employee,
            employeeId: this.employee.id,
        };
    }

    isEmptyTeam() {
        return !this.team;
    }

    isEmptyEmployee() {
        return !this.employee;
    }

    isValidTeam() {
        if (!this.team) {
            return false;
        }

        return this.hasValidDates();
    }

    isValidEmployee() {
        if (!this.employee) {
            return false;
        }

        return this.hasValidDates();
    }

    hasValidDates() {
        if (!this.start) {
            return false;
        }
        if (this.end && this.start > this.end) {
            return false;
        }

        return true;
    }

    formattedStart() {
        return format(this.start, 'dd.MM.yyyy');
    }

    formattedEnd() {
        return this.end === null ? null : format(this.end, 'dd.MM.yyyy');
    }
}
